export enum AuthStatus {
  NOT_LOGGED_IN = "notLoggedIn",
  LOGGED_IN_SUCCESS = "loggedInSuccess",
  LOGGED_IN_FAILURE = "loggedInFailure",
}

export enum DialogStatus {
  SUCCESS = "success",
  FAILURE = "failure",
}

/* global Office */
export const signIn = async (setState: (x) => void) => {
  let loginDialog: Office.Dialog;
  const dialogLoginUrl: string =
    location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") + "/login.html";
  await Office.context.ui.displayDialogAsync(dialogLoginUrl, { height: 40, width: 30 }, (result) => {
    if (result.status === Office.AsyncResultStatus.Failed) {
      console.error("Async Display Dialog failed " + result.status);
    } else {
      loginDialog = result.value;
      loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processLoginMessage);
    }
  });

  const processLoginMessage = (arg: { message?: string; origin?: string | undefined; error?: number }) => {
    const messageFromDialog = arg?.message ? JSON.parse(arg.message) : {};
    if (messageFromDialog.status === DialogStatus.SUCCESS) {
      // We now have a valid access token. We will now register the Excel Events and close the dialog box.
      loginDialog.close();
      setState(AuthStatus.LOGGED_IN_SUCCESS);
    } else {
      // Something went wrong with authentication or the authorization of the web application.
      setState(AuthStatus.LOGGED_IN_FAILURE);
      loginDialog.close();
    }
  };
};
